import { Icon } from '@components/Icon.tsx';
import { IconType } from '@src/IconType.ts';
import { classNames } from '@utils/classNames';

type CloseButtonProps = {
  onClick: () => void;
  className?: string;
  testId?: string;
};

export default function CloseButton({
  className,
  onClick,
  testId,
  ...rest
}: CloseButtonProps &
  Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'>) {
  return (
    <button
      {...rest}
      className={classNames(
        className,
        'bg-white hover:bg-gray-100 active:bg-gray-100',
        'rounded',
      )}
      onClick={onClick}
      {...(testId ? { 'data-testid': testId } : {})}
    >
      <Icon type={IconType.X} className="w-6 h-6" />
    </button>
  );
}
